import { render, staticRenderFns } from "./MasterAwbdispatch.vue?vue&type=template&id=2b305434&"
import script from "./MasterAwbdispatch.vue?vue&type=script&lang=js&"
export * from "./MasterAwbdispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports